module.exports = __webpack_public_path__ + "img/zc-12.a92b93b2.svg";